module.exports = __webpack_public_path__ + "img/chr_ts_25.6b4f743f.png";